import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import axios from "axios";
import { useAuth } from "../context/AuthContext";
import Landing from "./landing/Landing";

const Spinner = () => (
  <div className="min-h-screen flex items-center justify-center bg-[#0a0d14]" data-testid="root-loading">
    <div className="h-10 w-10 rounded-full border-2 border-amber-500/30 border-t-amber-500 animate-spin" />
  </div>
);

export default function RootPage() {
  const { user } = useAuth();
  const [site, setSite] = useState(null);
  useEffect(() => {
    if (user !== false) return;
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/public/sito`).then(({ data }) => setSite(!!data.enabled)).catch(() => setSite(false));
  }, [user]);

  if (user === null) return <Spinner />;
  if (user) {
    if (user.role === "superadmin") return <Navigate to="/admin/dashboard" replace />;
    if (user.role === "cliente") return <Navigate to="/cliente" replace />;
    return <Navigate to="/app/dashboard" replace />;
  }
  if (site === null) return <Spinner />;
  return site ? <Landing /> : <Navigate to="/login" replace />;
}
